<div class="loading-container" *ngIf="!schedulesLoaded">
  <circular-indicator [size]="100"></circular-indicator>
</div>

<app-no-content *ngIf="schedulesLoaded && history.length === 0" type="{{ 'no-services.title' | translate}}"
  [vin]="vin"></app-no-content>

<div class="schedule-list" *ngIf="schedulesLoaded && history.length > 0">
  <div *ngFor="let h of history">
    <lib-accordion foreground="light" [header]="h.extendedDate" (click)="getScheduleDetails(h)">
      <section class="service-container">

        <!-- data e hora -->
        <app-card
          title="{{ 'date-and-hour' | translate | uppercase }}"
          text="{{ h.parsedDate +' - '+ (h.scheduleHour | hour )}}"
        >
        </app-card>

        <!-- dealer -->
        <app-card
          *ngIf="h.dealerName !== '' || h.dealerStreet !== ''"
          title="{{ 'dealer' | translate | uppercase }}"
          text="{{ h.dealerName }}"
          optional="{{ h.dealerStreet }}"
        >
        </app-card>

        <div class="loading-container" *ngIf="!h.scheduleDetails">
          <circular-indicator [size]="100"></circular-indicator>
        </div>

        <div class="service-container" *ngIf="h.scheduleDetails && h.scheduleDetails.totalPrice !== undefined && h.scheduleDetails.requestedItems.services.length > 0">

          <!-- servicos realizados -->
          <div class="service-container__overview" *ngIf="revision">
            <h2>{{ "services-revision" | translate | uppercase }}</h2>

            <lib-table
              class="service-container__overview__table"
              [elements]="getRevisionPartsElements(revision.revisionParts)"
              [alternativeRows]="true"
              [noBorders]="true"></lib-table>

            <!-- TODO: Está comentado para não aparecer o valor, terá uma nova story para tratar valores com descontos -->
            <!-- <div class="service-container__overview__total mb-20">
              <div class="d-flex justify-content-between">
                <div>
                  <h3 class="f-size-14 l-height-20 f-weight-600">{{ "total-budget-revision" | translate }}</h3>
                </div>
                <div>
                  <p class="f-size-12 l-height-15 f-weight-600 service-container__overview__total__price" *ngIf="revision.price !== null && revision.price > 0">
                    {{ revision.price | currency: currency.currency }}
                  </p>
                  <p class="f-size-12 l-height-15 f-weight-600 service-container__overview__total__price" *ngIf="revision.price === null || revision.price === 0">
                    {{ 'budget.on-request' | translate }}
                  </p>
                </div>
              </div>
            </div> -->
          </div>

          <!-- servicos opcionais -->
          <div class="service-container__overview" *ngIf="services.length > 0">
            <h2>{{ "optional-services" | translate | uppercase }}</h2>

            <lib-table
              class="w-100 mb-30 optional"
              [elements]="getServicesElements(services)"
              [alternativeRows]="true"
              [noBorders]="true"></lib-table>

            <hr class="divider">
            <div class="service-container__overview__total">
              <div class="service-container__overview__total__card">
                <div>
                  <h3>{{ "total-budget" | translate | uppercase }}</h3>
                </div>
                <div>
                  @if (h.scheduleDetails.totalPrice !== null && h.scheduleDetails.totalPrice > 0) {
                    <p>{{ h.scheduleDetails.totalPrice | currency: currency.currency }}</p>
                  } @else if (h.scheduleDetails.totalPrice === null || h.scheduleDetails.totalPrice === 0) {
                    <p>{{ 'budget.on-request' | translate }}</p>
                  }
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </lib-accordion>

  </div>
</div>
